import auth from './auth'
import plaka from './plaka'

export default [auth, plaka]
